/***
 * Fichier d'initialisation de la base de données IndexedDB pour myOpen
 */
import Dexie from "dexie";

if (navigator.storage && navigator.storage.persist)
    navigator.storage.persist().then(function (persistent) {
        if (persistent) console.warn("Storage will not be cleared except by explicit user action");
        else console.warn("Storage may be cleared by the UA under storage pressure.");
    });

const db = new Dexie("MyOpen");

// => Saisie des temps et fluide
db.version(1).stores({
    User: "email",
    Imputation: "id, day_id",
    Day: "++id, user_id, date, [user_id+date]",
    Parameter: "user_id",
    Report: "++id, week_name, user_id, [user_id+week_name]",
    ActivityType: "id",
    WorkOrder: "++id, day_id",
});

// => Parc machine et historique
db.version(2).stores({
    User: "email",
    Imputation: "id, day_id",
    Day: "++id, user_id, date, [user_id+date]",
    Parameter: "user_id",
    Report: "++id, week_name, user_id, [user_id+week_name]",
    ActivityType: "id",
    WorkOrder: "++id, day_id",
    SearchHistory: "++id, type, searchInput, [type+searchInput]",
});

// => AR/PPS
db.version(3).stores({
    User: "email",
    Imputation: "id, day_id",
    Day: "++id, user_id, date, [user_id+date]",
    Parameter: "user_id",
    Report: "++id, week_name, user_id, [user_id+week_name]",
    ActivityType: "id",
    WorkOrder: "++id, day_id",
    SearchHistory: "++id, type, searchInput, [type+searchInput]",
    Pps: "mobileId",
    Subcontractor: "id",
});

// => Intervention
db.version(4).stores({
    User: "email",
    Imputation: "id, day_id",
    Day: "++id, user_id, date, [user_id+date]",
    Parameter: "user_id",
    Report: "++id, week_name, user_id, [user_id+week_name]",
    ActivityType: "id",
    SearchHistory: "++id, type, searchInput, [type+searchInput]",
    Pps: "mobileId",
    Subcontractor: "id",
    Intervention: "mobile_id",
    Product: "id, default_code, categ_id, name",
    ProductCategory: "id, complete_name, code, gotProducts, parent_id, name",
    BlocTypes: "id",
});

// => Synchro
db.version(5).stores({
    User: "email",
    Imputation: "id, day_id",
    Day: "++id, user_id, date, [user_id+date]",
    Parameter: "user_id",
    Report: "++id, week_name, user_id, [user_id+week_name]",
    ActivityType: "id",
    SearchHistory: "++id, type, searchInput, [type+searchInput]",
    Pps: "mobileId",
    Subcontractor: "id",
    Intervention: "mobile_id",
    Product: "id, default_code, categ_id, name",
    ProductCategory: "id, complete_name, code, gotProducts, parent_id, name",
    BlocTypes: "id",
    Synchronisations: "typeCode",
});

// => news
db.version(6).stores({
    User: "email",
    Imputation: "id, day_id",
    Day: "++id, user_id, date, [user_id+date]",
    Parameter: "user_id",
    Report: "++id, week_name, user_id, [user_id+week_name]",
    ActivityType: "id",
    SearchHistory: "++id, type, searchInput, [type+searchInput]",
    Pps: "mobileId",
    Subcontractor: "id",
    Intervention: "mobile_id",
    Product: "id, default_code, categ_id, name",
    ProductCategory: "id, complete_name, code, gotProducts, parent_id, name",
    BlocTypes: "id",
    Synchronisations: "typeCode",
    News: "[notif_date+notif_title], notif_date",
});

// => Site monitoring
db.version(7).stores({
    User: "email",
    Imputation: "id, day_id",
    Day: "++id, user_id, date, [user_id+date]",
    Parameter: "user_id",
    Report: "++id, week_name, user_id, [user_id+week_name]",
    ActivityType: "id",
    SearchHistory: "++id, type, searchInput, [type+searchInput]",
    Pps: "mobileId",
    Subcontractor: "id",
    Intervention: "mobile_id",
    Product: "id, default_code, categ_id, name",
    ProductCategory: "id, complete_name, code, gotProducts, parent_id, name",
    BlocTypes: "id",
    Synchronisations: "typeCode",
    News: "[notif_date+notif_title], notif_date",
    SiteMonitoring: "id",
    SiteMonitoringNote: "mobile_id, create_date",
    SiteMonitoringLot: "id, create_date",
    SiteMonitoringPlan: "id, create_date",
    SiteMonitoringComment: "id",
});

db.on("ready", function callback() {}, false);
db.open();

window.addEventListener("unhandledrejection", (e) => {
    console.error("Une erreur s'est produite pendant l'exécution d'une requête", e);
});

export default db;
